import * as types from './action-types';

export const initialState = {
  quotes: [],
  fetchingQuotes: false,
  fetchingQuoteSummary: false,
  quoteSummary: {
    Quote: {},
    Questions: [],
    Status: {}
  },
  totalQuotes: 0,
  dateFilter: {
    type: 1,
    value: 1
  }
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    
    /*************************Fetch quotes action states START ***************************/
      case `${types.FETCH_QUOTES}_PENDING`: 
        return Object.assign({}, state, {
          fetchingQuotes: true
        });

      case `${types.FETCH_QUOTES}_FULFILLED`:
        return Object.assign({}, state, {
          fetchingQuotes: false,
          quotes: action.payload.Details,
          totalQuotes: action.payload.Total
        });

      case `${types.FETCH_QUOTES}_REJECTED`:
        return {
          isRejected: true,
          error: 'Fetch Quotes action Failed'
        };  
    /*************************Fetch Question action states END ***************************/

    /*************************Fetch quote summary action states START ***************************/
      case `${types.FETCH_QUOTE_SUMMARY}_PENDING`: 
        return Object.assign({}, state, {
          fetchingQuoteSummary: true
        });

      case `${types.FETCH_QUOTE_SUMMARY}_FULFILLED`:
        return Object.assign({}, state, {
          fetchingQuoteSummary: false,
          quoteSummary: action.payload
        });

      case `${types.FETCH_QUOTE_SUMMARY}_REJECTED`:
        return {
          isRejected: true,
          error: 'Fetch Quote Summary action Failed'
        };  
    /*************************Fetch quote summary action states END ***************************/
    case types.SET_FILTER:
      return Object.assign({}, state, {
        dateFilter: action.data
      });

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/workflow/reducer.js